import { playgroundApi } from '../../common/api-client';
import {
  BaseMonthlyPolicyRow, BasePolicyRow, BaseSavingsInsuranceResponse, buildRatePayload,
} from '../_shared';
import { FamilySavingsInsuranceFormValues } from './schema';

export const PRODUCT = 'FAMILY_SAVINGS_INSURANCE';

export interface FamilySavingsPolicyRow extends BasePolicyRow {
  withdrawal?: number;
  policy_value_before_withdrawal?: number;
  policy_value_after_withdrawal?: number;
}

export interface FamilySavingsMonthlyPolicyRow extends BaseMonthlyPolicyRow {
  withdrawal?: number;
  policy_value_before_withdrawal?: number;
  policy_value_after_withdrawal?: number;
}

export interface FamilySavingsInsuranceResponse
  extends BaseSavingsInsuranceResponse<FamilySavingsPolicyRow, FamilySavingsMonthlyPolicyRow> {
  withdrawal_amount?: number;
  withdrawal_period_months?: number;
  terminal_excess?: number;
  // Present only in savings_capacity mode with an objective (coverage solve).
  coverage_factor?: number;
  funded_goal?: number;
  funded_withdrawal_amount?: number;
  objective_achieved_month?: number;
}

export interface SimulateParams {
  values: FamilySavingsInsuranceFormValues;
}

export function buildFamilySavingsPayload(values: FamilySavingsInsuranceFormValues) {
  const {
    rate_mode: _rateMode,
    projection_rate: _projectionRate,
    projection_rate_schedule: _projectionRateSchedule,
    // UI-only: drives objective-field visibility, not understood by the backend.
    // The backend infers the objective from the presence of goal / withdrawal.
    // Present only on the savings_capacity variant, so widen the type to strip it
    // uniformly across the discriminated union.
    capacity_objective: _capacityObjective,
    ...rest
  } = values as FamilySavingsInsuranceFormValues & { capacity_objective?: string };
  return { ...rest, ...buildRatePayload(values) };
}

export async function simulateFamilySavingsInsurance({
  values,
}: SimulateParams): Promise<FamilySavingsInsuranceResponse> {
  const payload = {
    product: PRODUCT,
    origin_process_id: `playground-${crypto.randomUUID().slice(0, 8)}`,
    ...buildFamilySavingsPayload(values),
    debug: true,
  };
  const { data } = await playgroundApi.post<FamilySavingsInsuranceResponse>(
    'projection/',
    payload,
  );
  return data;
}
